import { Parser, parseString } from "./parser";
import { Builder } from "./builder";
export { Parser, parseString, Builder };
//# sourceMappingURL=browser.js.map